import { React, Styled } from '@common/3rd';
import { ModelWidget } from '@component';
import Alert from '@alert';
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';
// @ts-ignore
window.jsPDF = jsPDF
class DeskPrint <
    P extends {
        source: any,
        filename: any,
        method: any,
        buttonname: any,
        info?:any
    },
    S,
    C extends { Box: any,Buttons: any}
    > extends ModelWidget<P, S, C> {
        normal:any;
        bold:any;
        protected initComponents(): C {
            return {
                Box: Styled.div.attrs({
                    'data-widget': 'desk-print'
                })`
                    ${props => this.renderCSS(props.theme)}
                `,
            } as C;
        }
        async componentDidMount() {
            super.componentDidMount();
        }

        protected async renderPrint(source:any, filename:any) {
            try {
                Alert.ing(`${this.props.info?this.props.info:'请稍后'}`)
                // @ts-ignore
                let [r1, r2] = await Promise.all([fetch('/rmcp/simhei-normal.md',{catch: 'force-cache'}), fetch('/rmcp/simhei-bold.md',{catch: 'force-cache'})]);
                this.normal = await r1.text();
                this.bold = await r2.text();
            } catch (e) {
                console.log('fetch error', e)
            } finally {
                Alert.hide();
            }
            if (this.normal && this.bold) {
                 // @ts-ignore
                let pdf = new window.jsPDF({
                    orientation: 'p',
                    format: 'a4',
                    unit: 'px',
                    hotfixes: ['px_scaling']
                });
                pdf.addFileToVFS('SourceHanSans-Normal.ttf', this.normal);
                pdf.addFileToVFS('SourceHanSans-Bold.ttf', this.bold);
                pdf.addFont('SourceHanSans-Normal.ttf', 'SourceHanSans-Normal', 'normal');
                pdf.addFont('SourceHanSans-Bold.ttf', 'SourceHanSans-Normal', 'bold');
                pdf.setFont('SourceHanSans-Normal');
                // @ts-ignore
                window.html2canvas = html2canvas;
                let sourceDom = document.querySelector(source).cloneNode(true);
                sourceDom.setAttribute('data-widget', 'source-copy');
                document.body.append(sourceDom);
                console.log(pdf.internal.pageSize.getWidth())
                pdf.html(document.querySelector('[data-widget=source-copy]') as HTMLElement, {
                    callback: ( pdf: any ) => {
                        pdf.save(filename);
                        document.querySelector('[data-widget=source-copy]')?.remove();
                    },
                    x: 20,
                    y: 20
                });
            }
        }

        protected renderInterface(source:any){
        }

        render() {
            const { Box } = this.getComponents();
            return (
                <Box  onClick={()=>{
                    this.props.method === 'jspdf' ? this.renderPrint(this.props.source,this.props.filename):this.renderInterface(this.props.source)
                }}>
                    {this.props.buttonname}
                </Box>
            );
        }
}

export { DeskPrint };
